import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { LoginComponent } from './_component/authorization/login/login.component';
import { ShakaPlayerComponent } from './_component/prime/shaka-player/shaka-player.component';
import { ShortsPlayerComponent } from './_component/prime/shorts-player/shorts-player.component';
import { AuthGuard } from './_guard/authguard.guard';
import { SearchComponent } from './_component/search/search.component';
import { WatchlistComponent } from './_component/watchlist/watchlist.component';
import { PercategoryComponent } from './_component/prime/percategory/percategory.component';
import { VideoDetailsComponent } from './_component/prime/video-details/video-details.component';
import { CcPrimeCategoryComponent } from './_component/cc_prime/cc-prime-category/cc-prime-category.component';
import { CcPrimePlayerComponent } from './_component/cc_prime/cc-prime-player/cc-prime-player.component';
import { WatchhistoryComponent } from './_component/watchhistory/watchhistory.component';
import { CategoryMovieComponent } from './_component/prime/category-movie/category-movie.component';
import { ToqqerRegisterComponent } from './_component/authorization/toqqer-register/toqqer-register.component';
import { DownloadlistComponent } from './_component/downloadlist/downloadlist.component';
import { AccountComponent } from './_component/account/account.component';
import { WalletRewardsComponent } from './_component/wallet-rewards/wallet-rewards.component';
import { PaymentsComponent } from './_component/payments/payments.component';
import { SubscriptionModalComponent } from './_component/sharedComponents/subscription-modal/subscription-modal.component';
import { SettingsComponent } from './_component/settings/settings.component';
import { QueueComponent } from './_component/queue/queue.component';
import { WhiteLabelRedirectGuard } from './_guard/white-label-redirect.guard';
import { RegisteredUserGuard } from './_guard/registered-user.guard';
import { UserChannelComponent } from './_component/user-channel/user-channel.component';
import { CcPrimeMainComponent } from './_component/cc_prime/cc-prime-main/cc-prime-main.component';
import { WhiteLabelInvalidComponent } from './_component/sharedComponents/white-label-invalid/white-label-invalid.component';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'disabled',
  anchorScrolling: 'disabled'
};

const routes: Routes = [
  // Guest-browsable routes (AuthGuard acquires guest token if needed)
  { path: ':channel/v', component: CcPrimeMainComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/category', component: CcPrimeCategoryComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/f', component: CategoryMovieComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/movies/:movie/:vidLibId', component: VideoDetailsComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/shows/:series_id', component: VideoDetailsComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/search', component: SearchComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/browse/:item/:category_id/:category', component: PercategoryComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },

  // Registered-user-only routes (watch, account, downloads, etc.)
  { path: ':channel/v/watch', component: CcPrimePlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/movies/:movie/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/trailer/:title/:fileName/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/shows/:series_id/:episodeTitle/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/shorts/:id', component: ShortsPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/accounts', component: AccountComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/downloads', component: DownloadlistComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/continue-watching', component: WatchhistoryComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/watchlist', component: WatchlistComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/queue', component: QueueComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/settings', component: SettingsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/payment', component: PaymentsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/wallet', component: WalletRewardsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/channelplans', component: SubscriptionModalComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/channel/user', component: UserChannelComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: ':channel/:entry/live/event/:id', component: ShakaPlayerComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },

  { path: 'login', component: LoginComponent },
  { path: 'registration', component: ToqqerRegisterComponent },
  { path: ':channel/:entry/registration', component: ToqqerRegisterComponent },

  // Guest-browsable default routes
  { path: 'v', component: CcPrimeMainComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'category', component: CcPrimeCategoryComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'f', component: CategoryMovieComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'movies/:movie/:vidLibId', component: VideoDetailsComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'shows/:series_id', component: VideoDetailsComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'browse/:item/:category_id/:category', component: PercategoryComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },

  // Registered-user-only default routes
  { path: 'watch', component: CcPrimePlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'movies/:movie/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'trailer/:title/:fileName/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'shows/:series_id/:episodeTitle/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'trailer/:series_id/:fileName/:title/:vidLibId/watch', component: ShakaPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'shorts/:id', component: ShortsPlayerComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'accounts', component: AccountComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'downloads', component: DownloadlistComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'continue-watching', component: WatchhistoryComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'watchlist', component: WatchlistComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'queue', component: QueueComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'payment', component: PaymentsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'wallet', component: WalletRewardsComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'channelplans', component: SubscriptionModalComponent, canActivate: [AuthGuard, RegisteredUserGuard, WhiteLabelRedirectGuard] },
  { path: 'channel/user', component: UserChannelComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'live/event/:id', component: ShakaPlayerComponent, canActivate: [AuthGuard, WhiteLabelRedirectGuard] },
  { path: 'wl-invalid', component:WhiteLabelInvalidComponent },
  { path: '', redirectTo: 'v', pathMatch: 'full' },
  { path: '**', redirectTo: 'v' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],  
  exports: [RouterModule]
})
export class AppRoutingModule {

}

// const routes: Routes = [
//   { path: '', redirectTo: '/tqr/cc_prime', pathMatch: 'full' },

//   { path: 'login', component: LoginComponent},
//   { path: 'registration', component: ToqqerRegisterComponent },

//   {
//     path: 'tqr',
//     component: TqrComponent,
//     canActivate: [AuthGuard],
//     children: [
//       { path: '', redirectTo: 'cc_prime', pathMatch: 'full' },
//       { path: 'cc_prime', component: CcPrimeCategoryComponent },
//       // { path: 'category/:category', component: CcPrimeCategoryComponent },
//       { path: 'prime', component: CategoryMovieComponent },
//       { path: 'prime-1', component: CategoryComponent },
//       { path: 'channel', component: ChannelComponent },
//       { path: 'channel/user', component: UserChannelComponent },
//       { path: 'mycontent', component: MycontentComponent },
//       { path: 'search', component: SearchComponent }, 
//       { path: 'search/:source', component: SearchComponent },
//       { path: 'watchlist', component: WatchlistComponent },
//       { path: 'history', component: WatchhistoryComponent },
//       { path: ':item/:category_id/:category', component: PercategoryComponent },
//       { path: 'video', component: CcPrimePlayerComponent },
//       { path: 'video-details', component: VideoDetailsComponent },
//       { path: 'thumbnail', component: MovieThumbnailComponent },
//       { path: 'downloads', component: DownloadlistComponent },
//       { path: 'accounts', component: AccountComponent },
//       { path: 'payment', component: PaymentsComponent },
//       { path: 'wallet', component: WalletRewardsComponent },
//       { path: 'channelplans', component: SubscriptionModalComponent },
//       { path: 'settings', component: SettingsComponent },
//       { path: 'queue', component: QueueComponent }
//     ]
//   },
//   { path: 'shaka-player', component: ShakaPlayerComponent, canActivate: [AuthGuard] },
//   { path: '**', redirectTo: '/tqr/cc_prime' }
// ];